import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './TwoPaneResizablePanel.scss';
import { useResizeEffect } from '~/util';
import { DAY_VIEW_PRIORITY_TASK_HEIGHT } from './constants';

const clampSize = (size, min, max) => {
  console.log('clampSize', size, min, max, Math.min(Math.max(size, min || 0), max || size));
  return Math.min(Math.max(size, min || 0), max || size);
};

const TwoPaneResizablePanel = ({
  firstChild,
  secondChild,
  firstChildInitialSize,
  minimumSize,
  className,
  persistenceKey,
}) => {
  const [size, setSize] = useState(
    parseInt(localStorage.getItem(persistenceKey) || firstChildInitialSize)
  );
  const [originalSize, setOriginalSize] = useState(size);
  const [dragging, setDragging] = useState(false);
  const dragStartOffset = useRef();
  const wrapper = useRef();

  useResizeEffect(() => {
    console.log('TwoPaneResizablePanel - useResizeEffect');
    const clampedSize = clampSize(size, minimumSize, wrapper.current.clientHeight - minimumSize);
    setSize(clampedSize);
  });

  const handleDragStart = event => {
    dragStartOffset.current = { x: event.pageX, y: event.pageY };
    console.log('TwoPaneResizablePanel - handleDragStart', dragStartOffset.current);

    setDragging(true);
  };

  const handleDragEnd = () => {
    if (!dragging) return;
    console.log('TwoPaneResizablePanel - handleDragEnd');
    setDragging(false);
    const clampedSize = clampSize(size, minimumSize, wrapper.current.clientHeight - minimumSize);
    setOriginalSize(clampedSize);
    setSize(clampedSize);
    if (persistenceKey) localStorage.setItem(persistenceKey, clampedSize);
  };

  const handleDragUpdate = event => {
    if (!dragging) return;

    setSize(
      clampSize(
        originalSize + event.pageY - dragStartOffset.current.y,
        minimumSize,
        wrapper.current.clientHeight - minimumSize
      )
    );
  };

  const clampedSize = clampSize(
    size,
    minimumSize,
    (wrapper.current?.clientHeight || 10000) - minimumSize
  );

  return (
    <div
      className={cn('two-pane-resizable-panel', className)}
      onMouseUp={handleDragEnd}
      onMouseMove={handleDragUpdate}
      onMouseLeave={handleDragEnd}
      ref={wrapper}
    >
      <div
        className="two-pane-resizable-panel__first-child"
        style={{ height: `${clampedSize / 10}rem` }}
      >
        {firstChild}
      </div>
      <div
        className="two-pane-resizable-panel__separator"
        onMouseDown={handleDragStart}
        style={{ top: `${clampedSize / 10}rem` }}
      />
      <div
        className="two-pane-resizable-panel__second-child"
        style={{ height: `calc(100% - ${clampedSize / 10}rem)` }}
      >
        {secondChild}
      </div>
    </div>
  );
};

TwoPaneResizablePanel.propTypes = {
  firstChild: PropTypes.node,
  secondChild: PropTypes.node,
  firstChildInitialSize: PropTypes.number,
  minimumSize: PropTypes.number,
  className: PropTypes.string,
  persistenceKey: PropTypes.oneOf([DAY_VIEW_PRIORITY_TASK_HEIGHT]),
};

export default TwoPaneResizablePanel;
